$(function() {

    $.top = {};

    // durations

    $.top.calculateDuration = function() {
		$.top.duration = Math.round($(window).innerHeight() / 4 * 3); // 3/4
	};

    // init

    $.top.calculateDuration();

    // resize

    $(window).resize(function() {
        $.top.calculateDuration();
    });

    // timelines

    $.top.tl = {};

    // in

    // logo

	$.top.tl.in = new TimelineMax();

    $.top.tl.in.addLabel("start");
    $.top.tl.in.addLabel("annual-report", 0.5);

    $.top.tl.in.set("#top-container", { visibility: "visible" }, "start");﻿

    $.top.tl.in.from("#top-container .lu-logo-shield", 1, { opacity: 0, scaleX: 0, transformOrigin: "50% 50%", ease:Cubic.easeOut }, "start");
	$.top.tl.in.staggerFrom("#top-container .lu-logo-lakehead path", 1, { opacity: 0, ease:Cubic.easeIn }, 0.015, "start");
	$.top.tl.in.staggerFrom("#top-container .lu-logo-university path", 1, { opacity: 0, delay: 0.25, ease:Cubic.easeIn }, 0.015, "start");

    // annual report

    $.top.annualSplit = new SplitText("#top-container .title-annual", {type:"chars"});
    $.top.annualChars = $.top.annualSplit.chars;

    $.top.tl.in.staggerFrom($.top.annualChars, 1, { opacity: 0, ease:Cubic.easeIn }, 0.015, "annual-report");

    $.top.reportSplit = new SplitText("#top-container .title-report", {type:"chars"});
    $.top.reportChars = $.top.reportSplit.chars;

    $.top.tl.in.staggerFrom($.top.reportChars, 1, { opacity: 0, delay: 0.25, ease:Cubic.easeIn }, 0.015, "annual-report");

    // year

    $.top.yearWidth = $('#top-container .title-year').outerWidth();
    $.top.yearPos = $('#top-container .title-year').offset().left;
    $.top.yearOffset = Math.ceil($.windowWidth - $.top.yearPos);

    $.top.tl.in.fromTo("#top-container .title-year", 2, { x: $.top.yearOffset }, { x: 0, ease:Cubic.easeInOut }, "annual-report");

    // menu

    if ($.windowWidth > $.menuWidth * 3) {
        $('body').addClass('menu-active');
        $.top.tl.in.fromTo("#menu-overlay", 2, { x: $.menuWidth }, { x: 0, ease:Cubic.easeInOut }, "annual-report");
        $.top.tl.in.set("#menu-btn-container", { visibility: "visible" }, "annual-report");﻿
        $.top.tl.in.fromTo("#menu-btn-container", 2, { opacity: 0 }, { opacity: 1, delay: 1, ease:Cubic.easeInOut }, "annual-report");
    } else {
        $('#menu-btn-container').css('visibility','visible');
    }

    // arrow

    $.top.tl.arrow = new TimelineMax({ delay: 3, repeat: -1, repeatDelay: 2 });

    $.top.tl.arrow.addLabel("start");

	$.top.tl.arrow.fromTo('#top-container .scroll-arrow', 0.5, { opacity: 0, y: -32 }, { opacity: 1, y: 0, ease: Power1.easeOut }, "start");
    $.top.tl.arrow.to('#top-container .scroll-arrow', 0.5, { opacity: 0, y: 32, ease: Power1.easeIn });

    $.top.tl.arrow.play();

    // out

    $.top.tl.out = new TimelineMax();

    $.top.tl.out.addLabel("start");
    $.top.tl.out.addLabel("end", 2);

    $.top.tl.out.fromTo("#top-container .title-year", 2, { x: 0 }, { x: - ($.top.yearPos + $.top.yearWidth) }, "start");

    $.top.tl.out.add(function(){ $('body').removeClass('menu-active'); }, "end");

    new ScrollMagic.Scene({ triggerElement: '#top-trigger', triggerHook: 'onLeave', duration: $.top.duration })
		.on('start', function () {
			$.top.tl.in.seek($.top.tl.in.duration(), false);
            $.top.tl.arrow.pause(0);
		})
		.setTween($.top.tl.out)
		// .addIndicators({name: 'top'})
		.addTo($.controller);

});
